<template>
   <div class="files-wrapper">
    <div class="files-grid">
      <div
        v-for="(file,index) in conversationAttachments"
        :key="index"
        class="file-card"
      >

        <img
          v-if="file.preview"
          :src="file.preview"
          alt="Image preview"
          class="file-preview"
        />

         <!-- FALLBACK ICON for other files -->
        <fluent-icon
          v-else
          :icon="'document'"
          :size="40"
          class="file-icon-fallback"
        />

        <!-- Hover download button -->
        <woot-button
          class="download-btn "
          color-scheme="primary"
          variant="smooth"
          size="small"
          @click="downloadFile(file)"
        >
          <fluent-icon icon="arrow-download" />
        </woot-button>
      </div>
    </div>

    <div v-if="!conversationAttachments.length" class="no-label-message">
      <span>
        {{ $t('CONTACT_PANEL.CONVERSATION_FILES.NO_RECORDS_FOUND') }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  data(){
    return {}
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      conversationAttachments:"getConversationAttachments",
    }),
  },
  mounted(){
    this.$store.dispatch('fetchConversationAttachments', {
      conversationId: this.conversationId,
    });
  },
  watch: {
    conversationId(newVal, oldVal) {
      this.$store.dispatch('fetchConversationAttachments', {
        conversationId: newVal,
      });
    }
  },
  methods:{
    async downloadFile(file) {
      // Implement download logic here
      if (!file || !file.url) {
        console.warn("No file or URL to download");
        return;
      }

      // Use the file name or fallback
      const filename = file.filename || 'download';

      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = file.url;
      link.target = '_blank';

      // Set the download attribute to suggest filename
      link.setAttribute('download', filename);

      // Some browsers require the link to be in the DOM
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      document.body.removeChild(link);
    },
    // methods end
  },

}
</script>


<style lang="scss" scoped>
.files-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 0.5rem;
}

.file-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eee;
  text-align: center;
  transition: transform 0.2s ease;
  cursor: pointer;
  // max-height: 100px;

  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 4 / 3;  // fixed ratio, responsive height


  &:hover {
    // transform: translateY(-3px);

    .download-btn {
      opacity: 1;
      visibility: visible;
    }
  }
}


.download-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease;
}

.file-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-label-message {
  margin-bottom: var(--space-normal);
  color: var(--b-500);
}

</style>